module.exports = __webpack_public_path__ + "img/so-logo-small.fc64f32b.png";